// @flow
// DEPRECATED - please use `import { track } from 'app/common/lib/react/analytics';` instead
import { connect } from 'react-redux';
import contextLog, { type ContextLogEventType } from 'app/common/redux/actions/contextLog';
import { bindActionCreators, type Dispatch } from 'redux';

// Flow typing for the prop injected by this withContextLog HOC
export type ContextLog = (name: ContextLogEventType, properties?: Object) => void;

function mapDispatchToProps(dispatch: Dispatch<any>) {
  return bindActionCreators({ contextLog }, dispatch);
}

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default connect(
  null,
  mapDispatchToProps,
);
